/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call */
import Agent from "sharedb/lib/agent";
import { Connection, Doc } from "sharedb/lib/client";
import ConnectionInternal from "sharedb/lib/client/connection";

/**
 * There is bug in our interaction with ShareDB presence that causes a presence request loop,
 * and this is a temporary measure to prevent the issue from occurring, at the cost of some
 * functionality.
 * The fix is turning requesting and reacting to "pr" (presenceRequest) actions into a no-op,
 * which means that arriving at a new Page will no longer request (and show) presence data
 * of existing users. Only subsequent new user interactions will show up.
 *
 * The _handlePresenceRequest prevents the client from handling presence requests, and
 * the _requestPresence prevents the server from sending presence requests to clients when
 * a new client subscribes to presences.
 */
ConnectionInternal.prototype._handlePresenceRequest = function _handlePresenceRequest() {
  // noop
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(Agent as any).prototype._requestPresence = function _requestPresence(_, callback?: () => void) {
  // noop
  if (callback) {
    callback();
  }
};

/**
 * Patches ShareDB client internals:
 * - Ignores non-ShareDB protocol messages (e.g. pong)
 * - Guards against null inflightSubscribe in _handleSubscribe:
 *   race when user navigates away before the subscribe response arrives.
 */
/* eslint-disable @typescript-eslint/no-explicit-any -- ShareDB internal API, no typed def */
export function patchShareDBConnection() {
  const originalHandleMessage = Connection.prototype.handleMessage;
  Connection.prototype.handleMessage = function handleMessage(message) {
    if (message.a === "pong") return;
    originalHandleMessage.call(this, message);
  };

  const DocProto = Doc.prototype as any;
  const originalHandleSubscribe = DocProto._handleSubscribe;
  DocProto._handleSubscribe = function _handleSubscribe(error?: any, snapshot?: any) {
    this.inflightSubscribe = this.inflightSubscribe || { callback: null, wantSubscribe: false };
    originalHandleSubscribe.call(this, error, snapshot);
  };
}
